import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { OpenReplayService } from '../services/open-replay/open-replay.service';
import { filter, map } from 'rxjs';

export const openReplayInterceptor: HttpInterceptorFn = (request, next) => {
  const replaySessionService = inject(OpenReplayService);
  return next(request).pipe(
    filter((event) => event instanceof HttpResponse),
    map((response: HttpResponse<any>) => {
      replaySessionService.sendNetworkEvent(`${request.url}`, { request, response })
      return response;
    }),
    map((event: HttpEvent<any>) => {
      return event
    })
  );
};
